import { Box } from "@mui/material";
import DOMPurify from "dompurify";
import { memo } from "react";

interface IQuestionGuidanceTextProps {
  guidanceText: string;
  maxWidth?: number;
}

export const QuestionGuidanceText = memo(
  ({ guidanceText, maxWidth = 600 }: IQuestionGuidanceTextProps) => (
    <Box
      sx={{
        width: "100%",
        maxWidth,
        mx: "auto",
        mt: 1,
        mb: 1,
        pointerEvents: "none",
      }}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(guidanceText) }}
    />
  ),
);
